import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { showMedicalRecord } from '../../actions/medicalRecords';
import { NavLink } from 'react-router-dom';

class PetInfo extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    pet: {Breed:{breed_type:''}},
  };

  componentWillReceiveProps = (nextProps) => {
    if(this.props.data !== nextProps.data) {
        this.setState({pet: nextProps.data});
    }

    if(this.props.data.newUser !== nextProps.data.newUser) {
        this.props.showMedicalRecord(this.props.petId);
    }

    if(nextProps.petId && this.props.petId !== nextProps.petId) {
        this.props.showMedicalRecord(nextProps.petId);
    }
  }

  componentDidMount = () => {
    this.props.showMedicalRecord(this.props.petId);
  }

  render() {
    const {pet} = this.state;
    return (
        <div className="row">
            <div className="col-xs-12 col-sm-8 col-md-8 col-lg-6 mx-auto">
                <div className="m-portlet m-portlet--full-height ">
                    <div className="m-portlet__body">
                        <div className="m-widget4">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="m-widget4__img m-widget4__img--pic mx-auto my-0">							 
                                        <img src={process.env.REACT_APP_S3_PATH + '/' + pet.avatar_path + '/' + pet.avatar_file_name} alt=""/>   
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="m-widget4__info mx-auto my-0 mt-2">
                                        <span className="m-widget4__title">
                                            {pet.Breed.breed_type}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                    <i className="fas fa-birthday-cake mr-2"></i>
                                    <span><strong>Birthday: </strong></span>
                                    {pet.date_of_birth}
                                </span>
                            </div>
                            <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                    <i className="fas fa-genderless mr-2"></i>
                                    <span><strong>Gender: </strong></span>
                                    {pet.sex}
                                </span>
                            </div>
                            <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                    <i className="fas fa-microchip mr-2"></i>
                                    <span><strong>Microchip: </strong></span>
                                    {pet.micro_chip}
                                </span>
                            </div>
                            <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                    <i className="fas fa-paint-brush mr-2"></i>
                                    <span><strong>Color: </strong></span>
                                    {pet.color_markings}
                                </span>
                            </div>
                            <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                    <i className="fas fa-folder-open mr-2"></i>
                                    <span><strong>Record Status: </strong></span>
                                    <span
                                        className={
                                        "m-badge mx-auto my-0 px-2 " +
                                        (pet.mc_status === "complete"
                                            ? "m-badge--success"
                                            : pet.mc_status !== "complete"
                                            ? "m-badge--warning"
                                            : " m-badge--wide")
                                        }
                                    >
                                        <strong>{pet.mc_status==='complete' ? 'COMPLETE' : 'DRAFT'}</strong>
                                    </span>
                                </span>
                            </div>
                            <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                    <i className="fas fa-print mr-2"></i>
                                    <span><strong>Availability: </strong></span>
                                    <span
                                        className={
                                        "m-badge mx-auto my-0 px-2 " +
                                        (!pet.Contract
                                            ? "m-badge--success"
                                            : "m-badge--danger")
                                        }
                                    >
                                        <strong>{pet.Contract ? 'SOLD' : 'AVAILABLE'}</strong>
                                    </span>
                                    
                                </span>
                            </div>	 		 
                        </div>
                    </div>
                </div>
            </div>
        </div>
            
 
    );
  }
}


const mapDispatchToProps = dispatch => ({
  
    showMedicalRecord: (id) => {
      dispatch(showMedicalRecord(id));
    }, 
    
});

const mapStateToProps = state => ({
    user: state.cognito.user,
    data: state.medicalRecordsReducer.showRecord
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PetInfo));